import React, { Component } from 'react';
import './SchoolGallery.css';
import { PATH } from '../../../../constants';

class SchoolGallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actualFrame: 0,
    };
  }

  // -------------------------------------------------------
  // Image
  // -------------------------------------------------------

  getImage(sheetId, name, actualFrame) {
    return (
      <img
        className="gallery-image"
        src={`${PATH.SCHOOL}img/${sheetId}/${name}-${actualFrame}.jpg`}
        alt="Galerie"
      />
    );
  }

  // -------------------------------------------------------
  // Navigation
  // -------------------------------------------------------

  swapFrame(direction) {
    const { length } = this.props.sectionData;
    let newFrame = this.state.actualFrame + direction;
    if (newFrame < 0) {
      newFrame = length - 1;
    } else if (newFrame === length) {
      newFrame = 0;
    }
    this.setState({ actualFrame: newFrame });
  }

  // -------------------------------------------------------
  // Render
  // -------------------------------------------------------

  render() {
    const { sheetId, sectionData } = this.props;
    const { actualFrame } = this.state;
    return (
      <div className="part gallery">
        {sectionData.full &&
        <a className="zoom-link" href={`${PATH.SCHOOL}img/${sheetId}/${sectionData.baseName}-${actualFrame}-full.jpg`} target="_blank">
          {this.getImage(sheetId, sectionData.baseName, actualFrame)}
          <img
            className="ico-zoom"
            src={`${PATH.IMG}ico/ico-zoom.png`}
            alt=""
          />
        </a>
        }
        {!sectionData.full &&
        this.getImage(sheetId, sectionData.baseName, actualFrame)
        }
        {sectionData.source.length > 0 &&
        <div className="source">{sectionData.source}</div>
        }
        <div className="navigation">
          <button
            className="arrow-btn left"
            onClick={() => this.swapFrame(-1)}
          >
            <img
              src={`${PATH.IMG}ico/ico-arrow-left.png`}
              alt="Předchozí"
            />
          </button>
          <div className="progress">{`${actualFrame + 1}/${sectionData.length}`}</div>
          <button
            className="arrow-btn right"
            onClick={() => this.swapFrame(1)}
          >
            <img
              src={`${PATH.IMG}ico/ico-arrow-right.png`}
              alt="Další"
            />
          </button>
        </div>
      </div>
    );
  }
}

export default SchoolGallery;




// WEBPACK FOOTER //
// ./src/components/App/SchoolDetail/SchoolGallery/SchoolGallery.js